import { IController } from 'angular';
import * as _ from 'lodash';

import { GraduationPlan as Plan } from '../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class OffTargetAssignmentCtrl implements IController {
  static inject: string[] = ['$scope', 'WizardUtils'];

  private activeStudentsByCohort;
  public explainer;
  public currentCohortFilter;
  private filteredStudentsByGp;

  public studentIdsWithCalcGpOffTarget: string[];
  public studentIdsWithCurrGpIncomplete: string[];
  public studentIdsWithCurrGpOther: string[];
  public studentIdsWithCurrGpNonGrad: string[];
  public filterOptions;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
      sort: [{ colId: 'countOfRegentsPassedAt65Of5', sort: 'desc' }],
    };

    this.currentCohortFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents({
      status: ['A', 'A-NDG'],
      cohort: [this.currentCohortFilter],
    });

    this.filteredStudentsByGp = this.generateFilteredStudentIdBuckets();

    this.studentIdsWithCalcGpOffTarget = this.filteredStudentsByGp.calculatedGpOffTarget;
    this.studentIdsWithCurrGpNonGrad = this.filteredStudentsByGp.currentGpNonGrad;
    this.studentIdsWithCurrGpIncomplete = this.filteredStudentsByGp.currentGpIncomplete;
    this.studentIdsWithCurrGpOther = this.filteredStudentsByGp.currentGpOther;

    this.explainer = this.WizardUtils.getGradPlanThresholdExplainer('Non-Graduate');
  }

  private generateFilteredStudentIdBuckets(): object {
    const calculatedGpOffTarget = [];
    const currentGpIncomplete = [];
    const currentGpNonGrad = [];
    const currentGpOther = [];

    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId, calculatedGradPlan, gradPlan } = student;

      if (calculatedGradPlan === '') {
        calculatedGpOffTarget.push(studentId);
        const gradPlanIncomplete = gradPlan === Plan.PLAN_INCOMPLETE.humanName;
        const gradPlanInPast = gradPlan === Plan.PLAN_IN_PAST.humanName;
        if (gradPlanIncomplete || gradPlanInPast) return currentGpIncomplete.push(studentId);
        if (gradPlan === Plan.NON_GRADUATE.humanName) {
          return currentGpNonGrad.push(studentId);
        } else return currentGpOther.push(studentId);
      }
    });
    return { calculatedGpOffTarget, currentGpIncomplete, currentGpNonGrad, currentGpOther };
  }
}
